/**
 * useTrustedInstitutions — device-scoped hook + helpers.
 *
 *   listRelationships(deviceId)       → GET  /wallet/institutions/relationships
 *   getInstitutionDetail(id, deviceId)→ GET  /wallet/institutions/{id}
 *   validateFsp(id, deviceId)         → POST /wallet/institutions/{id}/validate-fsp
 *   validateAdviser(id, repId, dev)   → POST /wallet/institutions/{id}/representatives/{repId}/validate
 */
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { loadWallet } from "@/lib/wallet-storage";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export function useTrustedInstitutions() {
  const wallet = loadWallet() || {};
  const deviceId = wallet.device_id;
  const [items, setItems]   = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!deviceId) { setLoading(false); return; }
    try {
      const { data } = await axios.get(`${API}/wallet/institutions/relationships`, { params: { device_id: deviceId } });
      setItems(data.items || []);
    } finally { setLoading(false); }
  }, [deviceId]);

  useEffect(() => { refresh(); }, [refresh]);
  return { items, loading, deviceId, refresh };
}

export async function getInstitutionDetail(institutionId, deviceId) {
  const { data } = await axios.get(`${API}/wallet/institutions/${institutionId}`, { params: { device_id: deviceId } });
  return data;
}

export async function validateFsp(institutionId, deviceId) {
  const { data } = await axios.post(`${API}/wallet/institutions/${institutionId}/validate-fsp`, { device_id: deviceId });
  return data;
}

export async function validateAdviser(institutionId, representativeId, deviceId) {
  const { data } = await axios.post(
    `${API}/wallet/institutions/${institutionId}/representatives/${representativeId}/validate`,
    { device_id: deviceId },
  );
  return data;
}
